<template>
  <div class="animated fadeIn">
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text> </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <v-col lg="12" class="ml-auto"></v-col>
    <b-card header-bg-variant="primary" header-text-variant="white">
      <template v-slot:header>
        <h6>اقلام در حال تولید - نقش شما در کارخانه: {{ roleName }}</h6>
      </template>

      <br />
      <p>برای مشاهده لیست اقلام در هر وضعیت، روی وضعیت مورد نظر کلیک کنید.</p>
      <b-btn
        class="m-1"
        v-for="status in statusOptions"
        :variant="
          status.text == selectedStatus.text
            ? 'dark text-light'
            : 'light text-dark'
        "
        :key="status.text"
        @click="selectStatus(status)"
        >{{ status.text }}</b-btn
      >
      <!-- <v-select
          label="وضعیت مورد نظر"
          :items="statusOptions"
          v-model="selectedStatus"
          @change="getTableInfo()"
          :disabled="isBusy"
          outlined
          dense
        /> -->
      <div>
        <b-card
          v-if="selectedStatus.text"
          class="shadow p-3 mb-5 bg-white rounded"
        >
          <vue-excel-xlsx
            v-if="items.length > 0 && !isBusy"
            style="float: left"
            class="mb-3 btn-dark rounded p-2"
            :data="items"
            :columns="
              fields
                .map((y) => {
                  return {
                    label: y.label,
                    field: y.key,
                  };
                })
                .filter((x) => x.field != 'index')
                .filter((x) => x.field != 'operation')
            "
            :file-name="
              'سفارشات_' + moment(new Date()).format('jYYYY-jMM-jDD_HH_mm_ss')
            "
            :sheet-name="'سفارشات'"
            >خروجی اکسل</vue-excel-xlsx
          >
          <p v-if="!isBusy" style="float: right">
            تعداد اقلام با وضعیت <strong>{{ selectedStatus.text }}</strong
            >: {{ items.length }}
            <b-btn class="mx-3" @click="getTableInfo()">
              <i class="fa fa-refresh"> </i>
            </b-btn>
          </p>
          <b-spinner v-else></b-spinner>
          <template v-slot:header>
            <h6>
              <b-input-group size="md">
                <b-form-input
                  v-model="filter"
                  type="search"
                  id="filterInput"
                  placeholder="جستجو"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    :disabled="!filter"
                    @click="filter = ''"
                    variant="danger"
                    >حذف</b-button
                  >
                </b-input-group-append>
              </b-input-group>
            </h6>
          </template>
          <b-table
            responsive
            show-empty
            :items="items"
            :fields="fields"
            empty-text="رکوردی برای نمایش وجود ندارد"
            striped
            :current-page="currentPage"
            :per-page="perPage"
            :busy="isBusy"
            :filter="filter"
            @filtered="currentPage = 1"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(code)="data">
              <div style="text-align: center; vertical-align: middle">
                <a
                  class="color mr-1 mt-1"
                  :href="'/factory/order/' + data.item.orderId"
                  target="_blank"
                  >{{ data.value }}</a
                >
              </div>
            </template>
            <template v-slot:cell(operation)="data">
              <div style="text-align: center; vertical-align: middle">
                <b-btn
                  variant="success"
                  class="mr-1 mt-1"
                  @click="process(data.item, 'next')"
                >
                  اتمام فرآیند
                </b-btn>
                <b-btn
                  variant="warning"
                  class="mr-1 mt-1"
                  @click="process(data.item, 'declined')"
                >
                  بدون نیاز به این مرحله
                </b-btn>
                <b-btn
                  variant="danger"
                  class="mr-1 mt-1"
                  @click="process(data.item, 'sendBack')"
                >
                  ارسال به مرحله قبل
                </b-btn>
              </div>
            </template>
            <div slot="table-busy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>

          <b-pagination
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="totalRows"
            align="center"
            size="md"
            class="my-0"
          ></b-pagination>
        </b-card>
      </div>

      <br />
    </b-card>

    <v-dialog v-model="editOrderItem" max-width="600px">
      <v-card>
        <v-card-title class="mb-3" style="padding-top: 38px">
          <h4>ویرایش {{ currentOrder.description }}</h4>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-text-field
              outlined
              dense
              label="شرح کالا"
              v-model="currentOrder.description"
            />

            <v-text-field
              outlined
              dense
              label="متریال"
              v-model="currentOrder.material"
            />

            <v-text-field
              outlined
              dense
              label="پوشش"
              v-model="currentOrder.coating"
            />

            <v-text-field
              outlined
              dense
              label="استاندارد ابعاد"
              v-model="currentOrder.dimensionStandard"
            />

            <v-text-field
              outlined
              dense
              label="قطر"
              v-model="currentOrder.diameter"
            />

            <v-text-field
              outlined
              dense
              label="طول"
              v-model="currentOrder.length"
            />

            <v-text-field
              outlined
              dense
              label="تعداد"
              v-model="currentOrder.number"
            />

            <v-select
              v-model="currentOrder.newStatus"
              :items="statusOptions"
              :label="
                'وضعیت جدید (وضعیت قبلی: ' + currentOrder.productionStatus + ')'
              "
              class="mt-3"
              outlined
              dense
            ></v-select>
            <p>توضیحات</p>
            <div class="item-ckeditor">
              <ckeditor
                v-model="currentOrder.orderItemNote"
              :editor="editor"
                  :config="editorConfig"
                @blur="onBlur($event)"
                @focus="onFocus($event)"
                @contentDom="onContentDom($event)"
                @dialogDefinition="onDialogDefinition($event)"
                @fileUploadRequest="onFileUploadRequest($event)"
                @fileUploadResponse="onFileUploadResponse($event)"
              />
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="editOrderItem = false">
            لغو
          </v-btn>
          <v-btn @click="editOrderItemId()" color="primary"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showProcessDialog" max-width="600px">
      <v-card>
        <v-card-title class="mb-3" style="padding-top: 38px">
          <h4>
            مراحل تولید {{ currentOrder.description }} --
            {{ currentOrder.type }}
          </h4>
        </v-card-title>
        <v-card-text>
          <p v-if="currentCommand == 'next'" style="color: green">
            شما در حال ارسال این کالا به مرحله بعد هستید و این به این معنی است
            که این مرحله از فرآیند تولید ({{ currentOrder.productionStatus }})
            توسط شما به پایان رسیده است.
          </p>
          <p v-else-if="currentCommand == 'declined'" style="color: goldenrod">
            شما در حال ارسال این کالا به مرحله بعد هستید و این به این معنی است
            که تولید این محصول نیازی به انجام این مرحله ({{
              currentOrder.productionStatus
            }}) ندارد.
          </p>
          <p v-else-if="currentCommand == 'sendBack'" style="color: red">
            شما در حال ارسال این کالا به مرحله قبل هستید و این به این معنی است
            که محصول هنوز برای تولید نیاز به مراحل قبلی دارد و پس از انجام آن
            شما قادر به انجام این مرحله خواهید بود.
          </p>

          <v-container v-if="currentOrder.type == 'پیچ'">
            <p>توضیحات</p>
            <div class="item-ckeditor">
              <ckeditor
                v-model="currentOrder.note"
            :editor="editor"
                  :config="editorConfig"
                @blur="onBlur($event)"
                @focus="onFocus($event)"
                @contentDom="onContentDom($event)"
                @dialogDefinition="onDialogDefinition($event)"
                @fileUploadRequest="onFileUploadRequest($event)"
                @fileUploadResponse="onFileUploadResponse($event)"
              />
            </div>
          </v-container>
          <v-container v-else-if="currentOrder.type == 'مهره'">
            <p>توضیحات</p>
            <div class="item-ckeditor">
              <ckeditor
                v-model="currentOrder.note"
              :editor="editor"
                  :config="editorConfig"
                @blur="onBlur($event)"
                @focus="onFocus($event)"
                @contentDom="onContentDom($event)"
                @dialogDefinition="onDialogDefinition($event)"
                @fileUploadRequest="onFileUploadRequest($event)"
                @fileUploadResponse="onFileUploadResponse($event)"
              />
            </div>
          </v-container>
          <v-container v-else>
            <v-select
              v-model="currentOrder.newStatus"
              :items="statusOptions"
              :label="
                'وضعیت جدید (وضعیت قبلی: ' + currentOrder.productionStatus + ')'
              "
              class="mt-3"
              outlined
              dense
            ></v-select>
            <p>توضیحات</p>
            <div class="item-ckeditor">
              <ckeditor
                v-model="currentOrder.note"
          :editor="editor"
                  :config="editorConfig"
                @blur="onBlur($event)"
                @focus="onFocus($event)"
                @contentDom="onContentDom($event)"
                @dialogDefinition="onDialogDefinition($event)"
                @fileUploadRequest="onFileUploadRequest($event)"
                @fileUploadResponse="onFileUploadResponse($event)"
              />
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn
            class="text-white"
            color="red"
            @click="showProcessDialog = false"
          >
            لغو
          </v-btn>
          <v-btn @click="doProcess()" color="primary"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Axios from "axios";
import Var from "../../../variables";
import moment from "moment-jalaali";
import router from "../../router";
import { CKEditor } from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
    CKEditor,
  },
  data: function () {
    return {
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          "bold",
          "italic",
          "underline",
          "strikethrough",
          "subscript",
          "superscript",
          "fontColor",
        ],
        height: 200,
        language: 'fa',
        contentsLangDirection: 'rtl',
      },
      guide: false,
      factory: new Object({
        code: "",
        dueDate: "",
      }),
      moment: moment,
      rejectReason: "",
      showProgress: false,
      uploadButDisable: false,
      variant: "info",
      striped: true,
      max: 100,
      uploadPercentage: 0,
      isUploaded: false,
      file: "",
      currentOrder: {},
      editOrderItem: false,
      showProcessDialog: false,
      currentCommand: "",

      items: [],
      filter: null,
      fields: [
        { key: "itemCode", label: "شماره سفارش" },
        { key: "type", label: "نوع کالا" },
        { key: "description", label: "نام" },
        { key: "material", label: "متریال" },
        { key: "coating", label: "پوشش" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "diameter", label: "قطر" },
        { key: "length", label: "طول" },
        { key: "number", label: "واحد" },
        { key: "priority", label: "اولویت تولید" },
        { key: "customerName", label: "نام مشتری" },
        { key: "code", label: "کد سفارش" },
        { key: "operation", label: "عملیات" },
      ],

      statusOptions: [
        { value: "بررسی اولیه", text: "بررسی اولیه" },
        // {
        //   value: "کنترل موجودی - انبار محصولات",
        //   text: "کنترل موجودی - انبار محصولات",
        // },
        // {
        //   value: "دستور تولید - مدیر کارخانه",
        //   text: "دستور تولید - مدیر کارخانه",
        // },
        // {
        //   value: "کنترل مواد - انبار مواد اولیه",
        //   text: "کنترل مواد - انبار مواد اولیه",
        // },
        { value: "برش", text: "برش" },
        { value: "سوراخکاری", text: "سوراخکاری" },
        { value: "کف تراشی", text: "کف تراشی" },
        { value: "پخ زنی", text: "پخ زنی" },
        { value: "داخل تراشی", text: "داخل تراشی" },
        { value: "قلاویز زنی", text: "قلاویز زنی" },
        { value: "اکسترود", text: "اکسترود" },
        { value: "فورج", text: "فورج" },
        { value: "ماشینکاری", text: "ماشینکاری" },
        { value: "مته مرغک زنی", text: "مته مرغک زنی" },
        { value: "شیارزنی", text: "شیارزنی" },
        { value: "فرزکاری", text: "فرزکاری" },
        { value: "پرداخت", text: "پرداخت" },
        { value: "آج زنی", text: "آج زنی" },
        { value: "مارک زنی", text: "مارک زنی" },
        { value: "دنده زنی", text: "دنده زنی" },
        { value: "عملیات حرارتی", text: "عملیات حرارتی" },
        // { value: "پوشش", text: "پوشش" },
        // { value: "بسته بندی", text: "بسته بندی" },
        // { value: "ارسال", text: "ارسال" },
      ],
      factoryRoles: {
        coldForgingSupervisor: "سرپرست فورج سرد",
        cuttingNutSupervisor: "مهره‌تراش",
        coatingSupervisor: "داک و پوشش",
        threadingSupervisor: "سرپرست رزوه زنی",
        machiningSupervisor: "سرپرست ماشین کاری و فرزکاری",
        cncSupervisor: "سرپرست CNC",
        knittingSupervisor: "سرپرست قلاویز زنی و مهره تراشی",
        weldingSupervisor: "سرپرست جوشکاری",
        heatTreatmentSupervisor: "سرپرست عملیات حرارتی و سیاه کاری",
        hotForgingSupervisor: "سرپرست فورج گرم",
        dichromateSupervisor: "سرپرست داکرومات",
        cuttingSupervisor: "سرپرست برشکاری",
        factoryGeneral: "کارمند کارخانه",
      },
      currentPage: 1,
      perPage: 10,
      isBusy: false,
      totalRows: "",
      striped: true,
      uniqueValues: [],
      content: "",
      config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "Subscript",
            "Superscript",
            "TextColor",
            "Font",
            "FontSize",
          ],
        ],
        height: 200,
      },

      role: "",
      roleName: "",
      selectedStatus: {},
    };
  },

  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },
    selectStatus(status) {
      this.selectedStatus = status;
      this.getTableInfo();
    },
    getTableInfo() {
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/factory/orderItems/getByProductionStatus",
        {
          productionStatus: this.selectedStatus.text,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.items = res.data;
            this.totalRows = this.items.length;
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.Busy = false;
          this.toast("خطا: " + err.response.data, "error");
          this.isBusy = false;
        });
    },
    showModalFollow(order) {
      this.currentOrder = order;
      this.editOrderItem = true;
    },
    editOrderItemId() {
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/factory/order/editOrderItemId",
        {
          orderItemId: this.currentOrder.id,
          status: "در مرحله تولید",
          productionStatus: this.currentOrder.newStatus,
          notes: this.currentOrder.orderItemNote,
          description: this.currentOrder.description,
          material: this.currentOrder.material,
          coating: this.currentOrder.coating,
          dimensionStandard: this.currentOrder.dimensionStandard,
          diameter: this.currentOrder.diameter,
          length: this.currentOrder.length,
          number: this.currentOrder.number,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.editOrderItem = false;
            this.getTableInfo();
            this.toast(res.data, "success");
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.Busy = false;
          this.toast("خطا: " + err.response.data, "error");
          this.isBusy = false;
        });
    },
    process(item, command) {
      this.currentOrder = item;
      this.currentCommand = command;
      this.currentOrder.note = "";
      this.currentOrder.type = "پیچ";
      this.showProcessDialog = true;
    },
    doProcess() {
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/factory/orderItem/productionStep",
        {
          orderItemId: this.currentOrder.id,
          processStatus: this.currentCommand,
          productionStatus: this.currentOrder.newStatus,
          notes: this.currentOrder.note,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.showProcessDialog = false;
            this.getTableInfo();
            this.toast(res.data, "success");
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.Busy = false;
          this.toast("خطا: " + err.response.data, "error");
          this.isBusy = false;
        });
    },
    closeModalّFollow() {
      this.currentOrder = {};
      this.$refs["modalFollow"].hide();
    },
    onBlur(evt) {},
    onFocus(evt) {},
    onContentDom(evt) {},
    onDialogDefinition(evt) {},
    onFileUploadRequest(evt) {},
    onFileUploadResponse(evt) {},
    updateOrder() {
      let baseId = this.currentOrder.totalOrder.custom_fields.filter(
        (x) => x.id == 158
      )[0].value;
      let currentId = this.currentOrder.taskId;
      Axios.put(
        this.baseUrl + "/issues/" + baseId + ".json",
        {
          issue: {
            uploads: [
              {
                token: this.mediaToken,
                filename: this.file.name,
                content_type: this.file.type,
              },
            ],
          },
        },
        {
          headers: {
            "X-Redmine-API-Key": window.localStorage.api_key,
          },
        }
      )
        .then(
          Axios.put(
            this.baseUrl + "/issues/" + currentId + ".json",
            {
              issue: {
                notes: this.content || "",
              },
            },
            {
              headers: {
                "X-Redmine-API-Key": window.localStorage.api_key,
              },
            }
          )
            .then(
              alert("پرونده با موفقیت به روز شد"),
              (this.content = ""),
              (this.file = ""),
              this.closeModalّFollow()
            )
            .catch((err2) => {
              console.log(err2);
            })
        )
        .catch((err) => {
          console.log(err);
        });
    },
    priceSent() {
      Axios.put(
        this.baseUrl + "/issues/" + this.currentOrder.taskId + ".json",
        {
          issue: {
            custom_fields: [
              {
                id: 159,
                value: this.sendMethod,
              },
              { id: 162, value: "در انتظار نظر مشتری" },
            ],
            uploads: [
              {
                token: this.mediaToken,
                filename: this.file.name,
                content_type: this.file.type,
              },
            ],
            notes: "پرونده برای مشتری ارسال شد. " + this.content || "",
          },
        },
        {
          headers: {
            "X-Redmine-API-Key": window.localStorage.api_key,
          },
        }
      )
        .then(
          alert("ارسال تعیین قیمت ثبت شد"),
          (this.content = ""),
          (this.file = ""),
          this.closeModalّFollowPrice(),
          this.getTableInfo()
        )
        .catch((err) => {
          console.log(err);
        });
    },
  },

  mounted() {
    // this.getTableInfo();
    this.role = window.localStorage.getItem("role");
    try {
      this.roleName = this.factoryRoles[this.role];
      if (!this.roleName) this.roleName = "سایر نقش‌ها";
    } catch (error) {
      this.roleName = "سایر نقش‌ها";
    }
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}

.progress {
  background-color: #222222 !important;
  padding-block-start: 20 px;
}
</style>
